import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_4 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_5 = {
  class: "flex items-center gap-1 bg-slate-100 rounded-lg p-1"
};
const _hoisted_6 = {
  key: 0,
  class: "bg-primary-50 border border-primary-200 rounded-xl p-3 mb-6"
};
const _hoisted_7 = {
  class: "flex items-center justify-between"
};
const _hoisted_8 = {
  class: "text-sm text-primary-700"
};
const _hoisted_9 = {
  key: 1,
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_10 = {
  class: "data-table-shell"
};
const _hoisted_11 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_12 = {
  class: "data-table text-sm"
};
const _hoisted_13 = {
  class: "data-table-head"
};
const _hoisted_14 = {
  class: "data-table-th text-left w-10"
};
const _hoisted_15 = ["checked", "indeterminate"];
const _hoisted_16 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_17 = ["checked", "onChange"];
const _hoisted_18 = {
  class: "data-table-td"
};
const _hoisted_19 = {
  class: "flex items-start gap-3"
};
const _hoisted_20 = ["onClick", "disabled"];
const _hoisted_21 = {
  key: 0,
  class: "w-3 h-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "flex items-start gap-2"
};
const _hoisted_24 = {
  key: 0,
  class: "px-2 py-0.5 status-badge is-danger text-xs rounded-full shrink-0 mt-0.5"
};
const _hoisted_25 = {
  key: 0,
  class: "text-xs text-slate-500 mt-0.5 line-clamp-3 break-all"
};
const _hoisted_26 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_27 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_28 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_29 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_30 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
const _hoisted_34 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-16"
};
const _hoisted_35 = {
  key: 1,
  class: "flex items-center justify-center py-12"
};
const _hoisted_36 = {
  key: 2,
  class: "grid grid-cols-4 gap-4"
};
const _hoisted_37 = {
  class: "bg-slate-100 rounded-xl p-4"
};
const _hoisted_38 = {
  class: "flex items-center justify-between mb-4"
};
const _hoisted_39 = {
  class: "flex items-center gap-2"
};
const _hoisted_40 = {
  class: "px-2 py-0.5 bg-slate-200 text-slate-600 text-xs rounded-full"
};
const _hoisted_41 = {
  class: "space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_44 = ["onClick"];
const _hoisted_45 = {
  class: "text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900"
};
const _hoisted_46 = {
  key: 0,
  class: "text-xs text-slate-500 mb-3 line-clamp-2"
};
const _hoisted_47 = {
  class: "flex items-center justify-between"
};
const _hoisted_48 = ["onClick"];
const _hoisted_49 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8 text-slate-500"
};
const _hoisted_50 = {
  class: "bg-blue-50 rounded-xl p-4"
};
const _hoisted_51 = {
  class: "flex items-center justify-between mb-4"
};
const _hoisted_52 = {
  class: "flex items-center gap-2"
};
const _hoisted_53 = {
  class: "px-2 py-0.5 bg-blue-200 text-blue-700 text-xs rounded-full"
};
const _hoisted_54 = {
  class: "space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1"
};
const _hoisted_55 = ["onClick"];
const _hoisted_56 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_57 = ["onClick"];
const _hoisted_58 = {
  class: "text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900"
};
const _hoisted_59 = {
  key: 0,
  class: "text-xs text-slate-500 mb-3 line-clamp-2"
};
const _hoisted_60 = {
  class: "flex items-center justify-between"
};
const _hoisted_61 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8 text-slate-500"
};
const _hoisted_62 = {
  class: "bg-green-50 rounded-xl p-4"
};
const _hoisted_63 = {
  class: "flex items-center justify-between mb-4"
};
const _hoisted_64 = {
  class: "flex items-center gap-2"
};
const _hoisted_65 = {
  class: "px-2 py-0.5 bg-green-500 text-white text-xs font-medium rounded-full shadow-sm"
};
const _hoisted_66 = {
  class: "space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1"
};
const _hoisted_67 = ["onClick"];
const _hoisted_68 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_69 = {
  class: "text-sm font-medium text-slate-600 mb-2 line-through decoration-green-400"
};
const _hoisted_70 = {
  key: 0,
  class: "text-xs text-slate-400 mb-3 line-clamp-2"
};
const _hoisted_71 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8 text-green-400"
};
const _hoisted_72 = {
  class: "bg-red-50 rounded-xl p-4"
};
const _hoisted_73 = {
  class: "flex items-center justify-between mb-4"
};
const _hoisted_74 = {
  class: "flex items-center gap-2"
};
const _hoisted_75 = {
  class: "px-2 py-0.5 bg-red-200 text-red-700 text-xs rounded-full"
};
const _hoisted_76 = {
  class: "space-y-3 max-h-[calc(100vh-320px)] overflow-y-auto pr-1"
};
const _hoisted_77 = ["onClick"];
const _hoisted_78 = {
  class: "flex items-start justify-between mb-2"
};
const _hoisted_79 = ["onClick"];
const _hoisted_80 = {
  class: "text-sm font-medium text-slate-800 mb-2 group-hover:text-slate-900"
};
const _hoisted_81 = {
  key: 0,
  class: "text-xs text-slate-500 mb-3 line-clamp-2"
};
const _hoisted_82 = {
  class: "flex items-center justify-between"
};
const _hoisted_83 = {
  class: "text-xs text-red-600"
};
const _hoisted_84 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8 text-slate-500"
};
const _hoisted_85 = {
  class: "p-6 space-y-4"
};
const _hoisted_86 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_87 = {
  class: "px-6 py-4 border-t border-slate-200 flex justify-end gap-3"
};
const _hoisted_88 = ["disabled"];
import { ref, reactive, computed, onMounted } from 'vue';
import { todoApi } from '@/api/todo';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import TodoDetailModal from '@/components/TodoDetailModal.vue';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'TodoManagement',
  setup(__props) {
    const userStore = useUserStore();

    // 视图模式
    const viewMode = ref('list');
    const searchKeyword = ref('');
    const filterPriority = ref('');
    const loading = ref(false);

    // 数据
    const listData = ref([]);
    const pagination = ref({
      current: 1,
      size: 20,
      total: 0,
      pages: 0
    });

    // 选中项
    const selectedIds = ref([]);

    // 弹窗状态
    const showCreateModal = ref(false);
    const showDetailModal = ref(false);
    const currentItem = ref(null);

    // 创建表单
    const createForm = reactive({
      title: '',
      description: '',
      priority: 2,
      dueDate: '',
      reminderTime: ''
    });

    // 看板列数据
    const PENDINGList = computed(() => listData.value.filter(t => t.status === 'PENDING'));
    const inProgressList = computed(() => listData.value.filter(t => t.status === 'IN_PROGRESS'));
    const COMPLETEDList = computed(() => listData.value.filter(t => t.status === 'COMPLETED'));
    const OVERDUEList = computed(() => listData.value.filter(t => t.overdue === true));

    // 全选状态
    const isAllSelected = computed(() => listData.value.length > 0 && selectedIds.value.length === listData.value.length);

    // 优先级映射
    const priorityMap = {
      1: {
        label: '低',
        class: 'px-2 py-0.5 status-badge is-neutral text-xs rounded-full'
      },
      2: {
        label: '中',
        class: 'px-2 py-0.5 status-badge is-warning text-xs rounded-full'
      },
      3: {
        label: '高',
        class: 'px-2 py-0.5 status-badge is-orange text-xs rounded-full'
      },
      4: {
        label: '紧急',
        class: 'px-2 py-0.5 status-badge is-danger text-xs rounded-full'
      }
    };

    // 获取优先级标签
    const getPriorityLabel = priority => priorityMap[priority]?.label || priority;
    const getPriorityBadgeClass = priority => priorityMap[priority]?.class || priorityMap[2].class;

    // 详情弹窗完成回调
    const onDetailComplete = () => {
      fetchData();
    };

    // 获取标题样式
    const getTitleClass = item => {
      if (item.status === 'COMPLETED') return 'text-slate-400 line-through';
      return 'text-slate-800';
    };

    // 获取截止日期样式
    const getDueDateClass = (date, isOVERDUE) => {
      if (!date) return 'text-slate-500';
      if (isOVERDUE) return 'text-red-600';
      return 'text-slate-600';
    };

    // 格式化日期
    const formatDate = date => {
      if (!date) return '未设置';
      const d = new Date(date);
      return `${d.getMonth() + 1}月${d.getDate()}日`;
    };

    // 获取数据
    const fetchData = async () => {
      loading.value = true;
      try {
        const params = {
          pageNum: pagination.value.current,
          pageSize: pagination.value.size,
          keyword: searchKeyword.value || undefined,
          priority: filterPriority.value || undefined
        };
        // 移除 undefined 值
        Object.keys(params).forEach(key => {
          if (params[key] === undefined) delete params[key];
        });
        const data = await todoApi.getList(params);
        // request 拦截器已处理 code === 0 的情况，data 直接是响应数据
        listData.value = data?.records || [];
        pagination.value = {
          current: data?.current || 1,
          size: data?.size || 20,
          total: data?.total || 0,
          pages: data?.pages || 0
        };
      } catch (error) {
        ElMessage.error('获取待办列表失败');
        console.error('获取待办列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const handleFilterChange = () => {
      pagination.value.current = 1;
      fetchData();
    };
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchData();
    };
    const handleReset = () => {
      searchKeyword.value = '';
      filterPriority.value = '';
      pagination.value.current = 1;
      fetchData();
    };
    const changePage = page => {
      pagination.value.current = page;
      fetchData();
    };
    const handlePageChange = page => {
      changePage(page);
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchData();
    };

    // 选择操作
    const toggleSelectAll = e => {
      if (e.target.checked) {
        selectedIds.value = listData.value.map(t => t.id);
      } else {
        selectedIds.value = [];
      }
    };
    const toggleSelect = id => {
      const index = selectedIds.value.indexOf(id);
      if (index > -1) {
        selectedIds.value.splice(index, 1);
      } else {
        selectedIds.value.push(id);
      }
    };
    const clearSelection = () => {
      selectedIds.value = [];
    };

    // 完成待办
    const completeItem = async item => {
      try {
        await todoApi.complete(item.id);
        // request 拦截器已处理成功响应，无需检查 code
        ElMessage.success('已完成');
        fetchData();
      } catch (error) {
        ElMessage.error('完成任务失败');
        console.error('完成任务失败:', error);
      }
    };
    const toggleItemComplete = item => {
      if (item.status !== 'COMPLETED') {
        completeItem(item);
      }
    };

    // 批量完成
    const batchComplete = async () => {
      if (selectedIds.value.length === 0) return;
      try {
        const count = await todoApi.batchComplete(selectedIds.value);
        ElMessage.success(`已完成 ${count || selectedIds.value.length} 项`);
        clearSelection();
        fetchData();
      } catch (error) {
        ElMessage.error('批量完成失败');
        console.error('批量完成失败:', error);
      }
    };

    // 删除待办
    const deleteItem = async item => {
      try {
        await ElMessageBox.confirm('确定要删除该待办吗？', '确认删除', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await todoApi.batchDelete([item.id]);
        ElMessage.success('删除成功');
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除失败');
          console.error('删除失败:', error);
        }
      }
    };

    // 批量删除
    const batchDelete = async () => {
      if (selectedIds.value.length === 0) return;
      try {
        await ElMessageBox.confirm(`确定要删除选中的 ${selectedIds.value.length} 项吗？`, '确认删除', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await todoApi.batchDelete(selectedIds.value);
        ElMessage.success(`删除成功`);
        clearSelection();
        fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('批量删除失败');
          console.error('批量删除失败:', error);
        }
      }
    };

    // 打开详情
    const openDetail = async item => {
      try {
        const data = await todoApi.getDetail(item.id);
        currentItem.value = data;
        showDetailModal.value = true;
      } catch (error) {
        ElMessage.error('获取详情失败');
        console.error('获取详情失败:', error);
      }
    };
    const closeDetailModal = () => {
      showDetailModal.value = false;
      currentItem.value = null;
    };

    // 创建待办
    const handleCreate = async () => {
      if (!createForm.title) {
        ElMessage.warning('请输入标题');
        return;
      }
      try {
        const data = {
          userId: userStore.userInfo?.id,
          title: createForm.title,
          description: createForm.description,
          priority: createForm.priority,
          dueDate: createForm.dueDate ? `${createForm.dueDate}T23:59:59` : undefined,
          reminderTime: createForm.reminderTime || undefined
        };
        await todoApi.create(data);
        ElMessage.success('创建成功');
        closeCreateModal();
        fetchData();
      } catch (error) {
        ElMessage.error('创建失败');
        console.error('创建失败:', error);
      }
    };
    const closeCreateModal = () => {
      showCreateModal.value = false;
      createForm.title = '';
      createForm.description = '';
      createForm.priority = 2;
      createForm.dueDate = '';
      createForm.reminderTime = '';
    };
    onMounted(() => {
      fetchData();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "待办事项"), _createElementVNode("p", {
          class: "list-page-description"
        }, "管理您的工作任务和待办事项")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => showCreateModal.value = true),
          class: "btn-primary inline-flex items-center gap-2"
        }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新建待办 ", -1)]))])])])])]),
        filters: _withCtx(() => [_createVNode(PageFilterBar, {
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchData
        }, {
          actions: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = $event => viewMode.value = 'list'),
            class: _normalizeClass(['px-3 py-1.5 rounded-md text-sm font-medium transition-colors', viewMode.value === 'list' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'])
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "w-4 h-4 inline",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 10h16M4 14h16M4 18h16"
          })], -1)]))], 2), _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = $event => viewMode.value = 'kanban'),
            class: _normalizeClass(['px-3 py-1.5 rounded-md text-sm font-medium transition-colors', viewMode.value === 'kanban' ? 'bg-white text-primary-600 shadow-sm' : 'text-slate-600 hover:text-slate-800'])
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
            class: "w-4 h-4 inline",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7"
          })], -1)]))], 2)])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            type: "button",
            onClick: handleReset,
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索待办事项...",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[14] || (_cache[14] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filterPriority.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filterPriority.value = $event),
            placeholder: "请选择优先级",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部优先级",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "低",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "中",
              value: 2
            }), _createVNode(_component_el_option, {
              label: "高",
              value: 3
            }), _createVNode(_component_el_option, {
              label: "紧急",
              value: 4
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"])]),
        default: _withCtx(() => [selectedIds.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, [_cache[17] || (_cache[17] = _createTextVNode("已选择 ", -1)), _createElementVNode("strong", null, _toDisplayString(selectedIds.value.length), 1), _cache[18] || (_cache[18] = _createTextVNode(" 项", -1))]), _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("button", {
          onClick: batchComplete,
          class: "px-3 py-1.5 text-sm text-green-700 bg-green-100 rounded-lg hover:bg-green-200 transition-colors"
        }, " 批量完成 "), _createElementVNode("button", {
          onClick: batchDelete,
          class: "px-3 py-1.5 text-sm text-red-700 bg-red-100 rounded-lg hover:bg-red-200 transition-colors"
        }, " 批量删除 "), _createElementVNode("button", {
          onClick: clearSelection,
          class: "px-3 py-1.5 text-sm text-slate-600 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 transition-colors"
        }, " 取消选择 ")])])])) : _createCommentVNode("", true), viewMode.value === 'list' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("table", _hoisted_12, [_createElementVNode("thead", _hoisted_13, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_14, [_createElementVNode("input", {
          type: "checkbox",
          checked: isAllSelected.value,
          indeterminate: selectedIds.value.length > 0 && selectedIds.value.length < listData.value.length,
          onChange: toggleSelectAll,
          class: "form-check"
        }, null, 40, _hoisted_15)]), _cache[19] || (_cache[19] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "待办事项", -1)), _cache[20] || (_cache[20] = _createElementVNode("th", {
          class: "data-table-th text-left w-25"
        }, "优先级", -1)), _cache[21] || (_cache[21] = _createElementVNode("th", {
          class: "data-table-th text-left w-30"
        }, "到期时间", -1)), _cache[22] || (_cache[22] = _createElementVNode("th", {
          class: "data-table-th text-left w-[90px]"
        }, "状态", -1)), _cache[23] || (_cache[23] = _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, item => {
          return _openBlock(), _createElementBlock("tr", {
            key: item.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_16, [_createElementVNode("input", {
            type: "checkbox",
            checked: selectedIds.value.includes(item.id),
            onChange: $event => toggleSelect(item.id),
            class: "form-check"
          }, null, 40, _hoisted_17)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("button", {
            onClick: $event => toggleItemComplete(item),
            disabled: item.status === 'COMPLETED' || item.status === 'cancelled',
            class: _normalizeClass(['w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors mt-0.5', item.status === 'COMPLETED' ? 'bg-green-500 border-green-500 text-white' : 'border-slate-300 hover:border-primary-500 cursor-pointer'])
          }, [item.status === 'COMPLETED' ? (_openBlock(), _createElementBlock("svg", _hoisted_21, [...(_cache[24] || (_cache[24] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "3",
            d: "M5 13l4 4L19 7"
          }, null, -1)]))])) : _createCommentVNode("", true)], 10, _hoisted_20), _createElementVNode("div", {
            class: "flex-1 min-w-0 cursor-pointer",
            onClick: $event => openDetail(item)
          }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("p", {
            class: _normalizeClass(['text-sm font-medium break-all', getTitleClass(item)])
          }, _toDisplayString(item.title), 3), item.overdue ? (_openBlock(), _createElementBlock("span", _hoisted_24, "逾期")) : _createCommentVNode("", true)]), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(item.description), 1)) : _createCommentVNode("", true)], 8, _hoisted_22)])]), _createElementVNode("td", _hoisted_26, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(item.priority))
          }, _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 3)]), _createElementVNode("td", _hoisted_27, [_createElementVNode("span", {
            class: _normalizeClass(['text-sm', getDueDateClass(item.dueDate, item.overdue)])
          }, _toDisplayString(formatDate(item.dueDate)), 3)]), _createElementVNode("td", _hoisted_28, [_createElementVNode("span", {
            class: _normalizeClass(['px-2 py-0.5 text-xs rounded-full font-medium', item.status === 'COMPLETED' ? 'status-badge is-success' : item.status === 'cancelled' ? 'status-badge is-neutral' : item.overdue ? 'status-badge is-danger' : item.status === 'IN_PROGRESS' ? 'status-badge is-info' : 'status-badge is-warning'])
          }, _toDisplayString(item.statusDesc || (item.status === 'COMPLETED' ? '已完成' : item.status === 'cancelled' ? '已取消' : item.overdue ? '已逾期' : item.status === 'IN_PROGRESS' ? '进行中' : '待办')), 3)]), _createElementVNode("td", _hoisted_29, [_createElementVNode("div", _hoisted_30, [item.status !== 'COMPLETED' ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: $event => completeItem(item),
            class: "table-action-button is-success",
            title: "完成",
            "aria-label": "完成"
          }, [...(_cache[25] || (_cache[25] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_31)) : _createCommentVNode("", true), _createElementVNode("button", {
            onClick: $event => openDetail(item),
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情"
          }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_32), _createElementVNode("button", {
            onClick: $event => deleteItem(item),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_33)])])]);
        }), 128))])])])]), listData.value.length === 0 && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_cache[28] || (_cache[28] = _createElementVNode("div", {
          class: "w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mb-4"
        }, [_createElementVNode("svg", {
          class: "w-10 h-10 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })])], -1)), _cache[29] || (_cache[29] = _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无待办事项", -1)), _createElementVNode("button", {
          onClick: _cache[5] || (_cache[5] = $event => showCreateModal.value = true),
          class: "btn-primary"
        }, " 立即创建 ")])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
          class: "w-8 h-8 animate-spin text-primary-500",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })], -1)]))])) : _createCommentVNode("", true), pagination.value.pages > 1 ? (_openBlock(), _createBlock(AppPagination, {
          key: 2,
          class: "pagination-bridge",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[31] || (_cache[31] = _createElementVNode("div", {
          class: "w-3 h-3 bg-amber-500 rounded-full"
        }, null, -1)), _cache[32] || (_cache[32] = _createElementVNode("h3", {
          class: "font-medium text-slate-700"
        }, "待办", -1)), _createElementVNode("span", _hoisted_40, _toDisplayString(PENDINGList.value.length), 1)]), _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = $event => showCreateModal.value = true),
          class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-200 rounded-lg transition-all duration-200 cursor-pointer"
        }, [...(_cache[33] || (_cache[33] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1)]))])]), _createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(PENDINGList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "bg-white rounded-lg border border-slate-200 p-4 hover:shadow-lg hover:border-amber-200 transition-all duration-200 ease-out cursor-pointer group",
            onClick: $event => openDetail(item)
          }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(item.priority))
          }, _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 3), _createElementVNode("button", {
            onClick: _withModifiers($event => deleteItem(item), ["stop"]),
            class: "p-1 text-slate-500 hover:text-red-500 hover:bg-red-50 rounded transition-all duration-200 opacity-0 group-hover:opacity-100",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[34] || (_cache[34] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_44)]), _createElementVNode("h4", _hoisted_45, _toDisplayString(item.title), 1), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_47, [_createElementVNode("span", {
            class: _normalizeClass(['text-xs', getDueDateClass(item.dueDate, item.overdue)])
          }, _toDisplayString(formatDate(item.dueDate)), 3), _createElementVNode("button", {
            onClick: _withModifiers($event => completeItem(item), ["stop"]),
            class: "p-1.5 text-slate-500 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200",
            title: "完成"
          }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_48)])], 8, _hoisted_42);
        }), 128)), PENDINGList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
          class: "w-8 h-8 mb-2 text-slate-300",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
        })], -1), _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无待办", -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_cache[37] || (_cache[37] = _createElementVNode("div", {
          class: "w-3 h-3 bg-blue-500 rounded-full"
        }, null, -1)), _cache[38] || (_cache[38] = _createElementVNode("h3", {
          class: "font-medium text-slate-700"
        }, "进行中", -1)), _createElementVNode("span", _hoisted_53, _toDisplayString(inProgressList.value.length), 1)])]), _createElementVNode("div", _hoisted_54, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inProgressList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "bg-white rounded-lg border border-blue-200 p-4 hover:shadow-lg hover:border-blue-300 transition-all duration-200 ease-out cursor-pointer group",
            onClick: $event => openDetail(item)
          }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(item.priority))
          }, _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 3), _createElementVNode("button", {
            onClick: _withModifiers($event => completeItem(item), ["stop"]),
            class: "p-1.5 text-slate-500 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100",
            title: "完成"
          }, [...(_cache[39] || (_cache[39] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_57)]), _createElementVNode("h4", _hoisted_58, _toDisplayString(item.title), 1), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_60, [_createElementVNode("span", {
            class: _normalizeClass(['text-xs', getDueDateClass(item.dueDate, item.overdue)])
          }, _toDisplayString(formatDate(item.dueDate)), 3)])], 8, _hoisted_55);
        }), 128)), inProgressList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_61, [...(_cache[40] || (_cache[40] = [_createElementVNode("svg", {
          class: "w-8 h-8 mb-2 text-slate-300",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M13 10V3L4 14h7v7l9-11h-7z"
        })], -1), _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无进行中", -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_cache[41] || (_cache[41] = _createElementVNode("div", {
          class: "w-3 h-3 bg-green-500 rounded-full shadow-sm"
        }, null, -1)), _cache[42] || (_cache[42] = _createElementVNode("h3", {
          class: "font-semibold text-green-800"
        }, "已完成", -1)), _createElementVNode("span", _hoisted_65, _toDisplayString(COMPLETEDList.value.length), 1)])]), _createElementVNode("div", _hoisted_66, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(COMPLETEDList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "bg-white rounded-lg border border-green-200 p-4 hover:shadow-lg hover:border-green-400 transition-all duration-200 ease-out cursor-pointer group",
            onClick: $event => openDetail(item)
          }, [_createElementVNode("div", _hoisted_68, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(item.priority))
          }, _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 3), _cache[43] || (_cache[43] = _createElementVNode("div", {
            class: "flex items-center gap-1"
          }, [_createElementVNode("span", {
            class: "px-1.5 py-0.5 bg-green-100 text-green-700 text-xs font-medium rounded"
          }, "已完成"), _createElementVNode("svg", {
            class: "w-5 h-5 text-green-500",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })])], -1))]), _createElementVNode("h4", _hoisted_69, _toDisplayString(item.title), 1), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_70, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _cache[44] || (_cache[44] = _createElementVNode("div", {
            class: "flex items-center justify-between"
          }, [_createElementVNode("span", {
            class: "text-xs text-green-600 font-medium"
          }, "已完成")], -1))], 8, _hoisted_67);
        }), 128)), COMPLETEDList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_71, [...(_cache[45] || (_cache[45] = [_createElementVNode("svg", {
          class: "w-8 h-8 mb-2",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1), _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无已完成", -1)]))])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_72, [_createElementVNode("div", _hoisted_73, [_createElementVNode("div", _hoisted_74, [_cache[46] || (_cache[46] = _createElementVNode("div", {
          class: "w-3 h-3 bg-red-500 rounded-full"
        }, null, -1)), _cache[47] || (_cache[47] = _createElementVNode("h3", {
          class: "font-medium text-slate-700"
        }, "已逾期", -1)), _createElementVNode("span", _hoisted_75, _toDisplayString(OVERDUEList.value.length), 1)])]), _createElementVNode("div", _hoisted_76, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(OVERDUEList.value, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "bg-white rounded-lg border border-red-200 p-4 hover:shadow-lg hover:border-red-300 transition-all duration-200 ease-out cursor-pointer group",
            onClick: $event => openDetail(item)
          }, [_createElementVNode("div", _hoisted_78, [_createElementVNode("span", {
            class: _normalizeClass(getPriorityBadgeClass(item.priority))
          }, _toDisplayString(item.priorityDesc || getPriorityLabel(item.priority)), 3), _createElementVNode("button", {
            onClick: _withModifiers($event => completeItem(item), ["stop"]),
            class: "p-1.5 text-slate-500 hover:text-green-500 hover:bg-green-50 rounded-lg transition-all duration-200 opacity-0 group-hover:opacity-100",
            title: "完成"
          }, [...(_cache[48] || (_cache[48] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_79)]), _createElementVNode("h4", _hoisted_80, _toDisplayString(item.title), 1), item.description ? (_openBlock(), _createElementBlock("p", _hoisted_81, _toDisplayString(item.description), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_82, [_createElementVNode("span", _hoisted_83, _toDisplayString(formatDate(item.dueDate)), 1)])], 8, _hoisted_77);
        }), 128)), OVERDUEList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_84, [...(_cache[49] || (_cache[49] = [_createElementVNode("svg", {
          class: "w-8 h-8 mb-2 text-slate-300",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        })], -1), _createElementVNode("span", {
          class: "empty-state-title"
        }, "暂无逾期", -1)]))])) : _createCommentVNode("", true)])])])), (_openBlock(), _createBlock(_Teleport, {
          to: "body"
        }, [_createVNode(_Transition, {
          name: "modal"
        }, {
          default: _withCtx(() => [_createVNode(AppModal, {
            visible: showCreateModal.value,
            size: "lg",
            "panel-class": "mx-4",
            onClose: closeCreateModal
          }, {
            default: _withCtx(() => [_cache[55] || (_cache[55] = _createElementVNode("div", {
              class: "px-6 py-4 border-b border-slate-200"
            }, [_createElementVNode("h3", {
              class: "text-lg font-semibold text-slate-900"
            }, "新建待办")], -1)), _createElementVNode("div", _hoisted_85, [_createElementVNode("div", null, [_cache[50] || (_cache[50] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, [_createTextVNode("标题 "), _createElementVNode("span", {
              class: "text-red-500"
            }, "*")], -1)), _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => createForm.title = $event),
              type: "text",
              class: "form-input w-full",
              placeholder: "请输入待办标题"
            }, null, 512), [[_vModelText, createForm.title]])]), _createElementVNode("div", null, [_cache[51] || (_cache[51] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => createForm.description = $event),
              rows: "3",
              class: "form-textarea",
              placeholder: "请输入描述"
            }, null, 512), [[_vModelText, createForm.description]])]), _createElementVNode("div", _hoisted_86, [_createElementVNode("div", null, [_cache[52] || (_cache[52] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "优先级", -1)), _createVNode(_component_el_select, {
              modelValue: createForm.priority,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => createForm.priority = $event),
              class: "form-select w-full"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "低",
                value: 1
              }), _createVNode(_component_el_option, {
                label: "中",
                value: 2
              }), _createVNode(_component_el_option, {
                label: "高",
                value: 3
              }), _createVNode(_component_el_option, {
                label: "紧急",
                value: 4
              })]),
              _: 1
            }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[53] || (_cache[53] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "到期时间", -1)), _createVNode(_component_el_date_picker, {
              modelValue: createForm.dueDate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => createForm.dueDate = $event),
              type: "date",
              format: "YYYY年MM月DD日",
              "value-format": "YYYY-MM-DD",
              placeholder: "请选择到期时间",
              class: "w-full"
            }, null, 8, ["modelValue"])])]), _createElementVNode("div", null, [_cache[54] || (_cache[54] = _createElementVNode("label", {
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "提醒时间", -1)), _createVNode(_component_el_date_picker, {
              modelValue: createForm.reminderTime,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => createForm.reminderTime = $event),
              type: "datetime",
              format: "YYYY年MM月DD日 HH:mm",
              "value-format": "YYYY-MM-DDTHH:mm:ss",
              placeholder: "请选择提醒时间",
              class: "w-full"
            }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_87, [_createElementVNode("button", {
              onClick: closeCreateModal,
              class: "px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
            }, " 取消 "), _createElementVNode("button", {
              onClick: handleCreate,
              disabled: !createForm.title,
              class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50"
            }, " 创建 ", 8, _hoisted_88)])]),
            _: 1
          }, 8, ["visible"])]),
          _: 1
        })])), _createVNode(TodoDetailModal, {
          show: showDetailModal.value,
          item: currentItem.value,
          onClose: closeDetailModal,
          onComplete: onDetailComplete
        }, null, 8, ["show", "item"])]),
        _: 1
      });
    };
  }
};